import { timeFormatDefaultLocale } from 'd3';

export function getLocale(lang) {
  if (lang === 'de') {
    return timeFormatDefaultLocale({
      decimal: ',',
      thousands: '.',
      grouping: [3],
      currency: ['€', ''],
      dateTime: '%a %b %e %X %Y',
      date: '%d-%m-%Y',
      time: '%H:%M:%S',
      periods: ['AM', 'PM'],
      days: [
        'Sonntag',
        'Montag',
        'Dienstag',
        'Mittwoch',
        'Donnerstag',
        'Freitag',
        'Samstag',
      ],
      shortDays: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
      months: [
        '',
        'Januar',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember',
      ],
      shortMonths: [
        '',
        'Jan',
        '',
        'Mar',
        '',
        'Mai',
        '',
        'Jul',
        '',
        'Sep',
        '',
        'Nov',
        '',
      ],
    });
  }

  if (lang === 'en') {
    return timeFormatDefaultLocale({
      decimal: ',',
      thousands: '.',
      grouping: [3],
      currency: ['€', ''],
      dateTime: '%a %b %e %X %Y',
      date: '%d-%m-%Y',
      time: '%H:%M:%S',
      periods: ['AM', 'PM'],
      days: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
      ],
      shortDays: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
      months: [
        '',
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
      shortMonths: [
        '',
        'Jan',
        '',
        'Mar',
        '',
        'May',
        '',
        'Jul',
        '',
        'Sep',
        '',
        'Nov',
        '',
      ],
    });
  }
  if (lang === 'fr') {
    return timeFormatDefaultLocale({
      decimal: ',',
      thousands: '.',
      grouping: [3],
      currency: ['€', ''],
      dateTime: '%a %b %e %X %Y',
      date: '%d-%m-%Y',
      time: '%H:%M:%S',
      periods: ['AM', 'PM'],
      days: [
        'dimanche',
        'lundi',
        'mardi',
        'mercredi',
        'jeudi',
        'vendredi',
        'samedi',
      ],
      shortDays: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
      months: [
        '',
        'janvier',
        'février',
        'mars',
        'avril',
        'mai',
        'juin',
        'juillet',
        'aôut',
        'septembre',
        'octobre',
        'novembre',
        'décembre',
      ],
      shortMonths: [
        '',
        'jan',
        '',
        'mar',
        '',
        'mai',
        '',
        'jui',
        '',
        'sep',
        '',
        'nov',
        '',
      ],
    });
  }

  return timeFormatDefaultLocale({
    decimal: ',',
    thousands: '.',
    grouping: [3],
    currency: ['€', ''],
    dateTime: '%a %b %e %X %Y',
    date: '%d.%m.%Y',
    time: '%H:%M:%S',
    periods: ['AM', 'PM'],
    days: [
      'zondag',
      'maandag',
      'dinsdag',
      'woensdag',
      'donderdag',
      'vrijdag',
      'zaterdag',
    ],
    shortDays: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
    months: [
      'januari',
      'februari',
      'maart',
      'april',
      'mei',
      'juni',
      'juli',
      'augustus',
      'september',
      'oktober',
      'november',
      'december',
    ],
    shortMonths: [
      '',
      'jan',
      '',
      'maa',
      '',
      'mei',
      '',
      'jul',
      '',
      'sep',
      '',
      'nov',
      '',
    ],
  });
}

/**
 * @param {'nl' | 'en' | 'fr' | 'de'} lang
 * @param {Oject} currentTech
 * @param {boolean} currentTech.solar
 * @param {boolean} currentTech.windOffshore
 * @param {boolean} currentTech.windOnshore
 */

export function getCategories(lang, currentTech) {
  let observedCategories;
  let forecastCategories;
  let observedSolarCategory;
  let forecastSolarCategory;
  let observedWindCategory;
  let forecastWindCategory;
  let observedWindOffshoreCategory;
  let forecastWindOffshoreCategory;

  switch (lang) {
    case 'de':
      observedSolarCategory = {
        key: 'solar',
        label: 'Sonne',
        symbolType: 'dot',
      };
      forecastSolarCategory = {
        key: 'solarForecast',
        label: 'Sonne',
        symbolType: 'dot',
      };
      observedWindCategory = {
        key: 'wind',
        label: 'Wind onshore',
        symbolType: 'dot',
      };
      forecastWindCategory = {
        key: 'windForecast',
        label: 'Wind onshore',
        symbolType: 'dot',
      };
      observedWindOffshoreCategory = {
        key: 'windOffshoreForecast',
        label: 'Wind offshore',
        symbolType: 'dot',
      };
      forecastWindOffshoreCategory = {
        key: 'windOffshoreForecast',
        label: 'Wind offshore',
        symbolType: 'dot',
      };
      break;
    case 'en':
      observedSolarCategory = {
        key: 'solar',
        label: 'solar',
        symbolType: 'dot',
      };
      forecastSolarCategory = {
        key: 'solarForecast',
        label: 'solar',
        symbolType: 'dot',
      };
      observedWindCategory = {
        key: 'wind',
        label: 'wind onshore',
        symbolType: 'dot',
      };
      forecastWindCategory = {
        key: 'windForecast',
        label: 'wind onshore',
        symbolType: 'dot',
      };
      observedWindOffshoreCategory = {
        key: 'windOffshoreForecast',
        label: 'wind offshore',
        symbolType: 'dot',
      };
      forecastWindOffshoreCategory = {
        key: 'windOffshoreForecast',
        label: 'wind offshore',
        symbolType: 'dot',
      };
      break;
    case 'fr':
      observedSolarCategory = {
        key: 'solar',
        label: 'door zonnepanelen',
        symbolType: 'dot',
      };
      forecastSolarCategory = {
        key: 'solarForecast',
        label: 'door zonnepanelen',
        symbolType: 'dot',
      };
      observedWindCategory = {
        key: 'wind',
        label: 'door onshore windturbines',
        symbolType: 'dot',
      };
      forecastWindCategory = {
        key: 'windForecast',
        label: 'door onshore windturbines',
        symbolType: 'dot',
      };
      observedWindOffshoreCategory = {
        key: 'windOffshoreForecast',
        label: 'door offshore windturbines',
        symbolType: 'dot',
      };
      forecastWindOffshoreCategory = {
        key: 'windOffshoreForecast',
        label: 'door offshore windturbines',
        symbolType: 'dot',
      };
      break;
    case 'nl':
    default:
      observedSolarCategory = {
        key: 'solar',
        label: 'door zonnepanelen',
        symbolType: 'dot',
      };
      forecastSolarCategory = {
        key: 'solarForecast',
        label: 'door zonnepanelen',
        symbolType: 'dot',
      };
      observedWindCategory = {
        key: 'wind',
        label: 'door onshore windturbines',
        symbolType: 'dot',
      };
      forecastWindCategory = {
        key: 'windForecast',
        label: 'door onshore windturbines',
        symbolType: 'dot',
      };
      observedWindOffshoreCategory = {
        key: 'windOffshoreForecast',
        label: 'door offshore windturbines',
        symbolType: 'dot',
      };
      forecastWindOffshoreCategory = {
        key: 'windOffshoreForecast',
        label: 'door offshore windturbines',
        symbolType: 'dot',
      };
  }

  if (currentTech.solar) {
    if (currentTech.wind) {
      if (currentTech.windOffshore) {
        observedCategories = [
          observedSolarCategory,
          observedWindCategory,
          observedWindOffshoreCategory,
        ];
        forecastCategories = [
          forecastSolarCategory,
          forecastWindCategory,
          forecastWindOffshoreCategory,
        ];
      } else {
        observedCategories = [observedSolarCategory, observedWindCategory];
        forecastCategories = [forecastSolarCategory, forecastWindCategory];
      }
    } else {
      if (currentTech.windOffshore) {
        observedCategories = [
          observedSolarCategory,
          observedWindOffshoreCategory,
        ];
        forecastCategories = [
          forecastSolarCategory,
          forecastWindOffshoreCategory,
        ];
      } else {
        observedCategories = [observedSolarCategory];
        forecastCategories = [forecastSolarCategory];
      }
    }
  } else {
    if (currentTech.wind) {
      if (currentTech.windOffshore) {
        observedCategories = [
          observedWindCategory,
          observedWindOffshoreCategory,
        ];
        forecastCategories = [
          forecastWindCategory,
          forecastWindOffshoreCategory,
        ];
      } else {
        observedCategories = [observedWindCategory];
        forecastCategories = [forecastWindCategory];
      }
    } else {
      observedCategories = [observedWindOffshoreCategory];
      forecastCategories = [forecastWindOffshoreCategory];
    }
  }

  return {
    observedCategories,
    forecastCategories,
  };
}

export function getDayAheadPricesCategory() {
  return [
    {
      key: 'price',
      label: 'Elektriciteitsprijs (c€/kWh) *',
      symbolType: 'line',
    },
  ];
}

/**
 * @param {'nl' | 'en' | 'fr' | 'de'} lang
 */

export function getProductionLabels(lang) {
  if (lang === 'de') {
    return {
      perMonth: ' per month',
      observedTitle: 'Waargenomen productie',
      forecastTitle: 'Verwachte productie',
      observedForecastTitle: 'Observed and expected production',
    };
  }
  if (lang === 'en') {
    return {
      perMonth: ' per month',
      observedTitle: 'Observed production',
      forecastTitle: 'Expected and production',
      observedForecastTitle: 'Observed and expected production',
    };
  }
  if (lang === 'fr') {
    return {
      perMonth: ' par mois',
      observedTitle: 'Production observée',
      forecastTitle: 'Production attendue',
      observedForecastTitle: 'Production observée et attendue',
    };
  }
  return {
    perMonth: ' per maand',
    observedTitle: 'Waargenomen productie',
    forecastTitle: 'Voorspelde productie',
    observedForecastTitle: 'Waargenomen en voorspelde productie',
    production: 'productie',
  };
}

/**
 * @param {'nl' | 'en' | 'fr' | 'de'} lang
 * @param {Object} currentTech
 * @param {Boolean} currentTech.solar
 * @param {Boolean} currentTech.windOnshore
 * @param {Boolean} currentTech.windOffshore
 */

export function getCommentTech(lang, currentTech) {
  if (lang === 'de') {
    return currentTech.solar
      ? currentTech.windOnshore
        ? currentTech.windOffshore
          ? 'solar panels and onshore and offshore wind turbines'
          : 'solar panels and onshore wind turbines'
        : currentTech.windOffshore
        ? 'solar panels and offshore wind turbines'
        : 'solar panels'
      : currentTech.windOnshore
      ? currentTech.windOffshore
        ? 'onshore and offshore wind turbines'
        : 'onshore wind turbines'
      : 'offshore wind turbines';
  }
  if (lang === 'en') {
    return currentTech.solar
      ? currentTech.windOnshore
        ? currentTech.windOffshore
          ? 'solar panels and onshore and offshore wind turbines'
          : 'solar panels and onshore wind turbines'
        : currentTech.windOffshore
        ? 'solar panels and offshore wind turbines'
        : 'solar panels'
      : currentTech.windOnshore
      ? currentTech.windOffshore
        ? 'onshore and offshore wind turbines'
        : 'onshore wind turbines'
      : 'offshore wind turbines';
  }
  if (lang === 'fr') {
    return currentTech.solar
      ? currentTech.windOnshore
        ? currentTech.windOffshore
          ? 'panneaux solaires et turbines éoliennes onshore et offshore'
          : 'panneaux solaires et turbines éoliennes onshore'
        : currentTech.windOffshore
        ? 'panneaux solaires et turbines éoliennes offshore'
        : 'panneaux solaires'
      : currentTech.windOnshore
      ? currentTech.windOffshore
        ? 'turbines éoliennes onshore et offshore'
        : 'turbines éoliennes onshore'
      : 'turbines éoliennes offshore';
  }

  // no NL?
}
/**
 * @param {'nl' | 'en' | 'fr' | 'de'} lang
 */

export function getInhabitantLabels(lang) {
  if (lang === 'de') {
    return {
      inhabitant: 'inwoner',
      hourIndicator: 'u',
    };
  }
  if (lang === 'en') {
    return {
      inhabitant: 'inhabitant',
      hourIndicator: 'h',
    };
  }
  if (lang === 'fr') {
    return {
      inhabitant: 'habitant',
      hourIndicator: 'h',
    };
  }

  // no NL?
}

/**
 *
 * @param {Boolean} isRealtime
 * @param {'energy' | 'inhabitants'} currentFilter
 */
export function getYAxisLabel(isRealtime, currentFilter) {
  if (isRealtime && currentFilter === 'energy') {
    return 'GW';
  }
  if (isRealtime && currentFilter === 'inhabitants') {
    return 'W/inwoner';
  }
  if (isRealtime) {
    return 'MW/100 km²';
  }
  if (currentFilter === 'energy') {
    return 'GWh';
  }
  if (currentFilter === 'inhabitants') {
    return 'Wh/inwoner';
  }
  return 'GWh/100 km²';
}

function getProductionNatureLabel(lang, hasForecast, hasMixedForecast) {
  const { observedForecastTitle, forecastTitle, observedTitle } =
    getProductionLabels(lang);
  return hasForecast
    ? hasMixedForecast
      ? observedForecastTitle
      : forecastTitle
    : observedTitle;
}

/**
 *
 * @param {'nl' | 'en' | 'fr' | 'de'} lang
 * @param {boolean} hasForecast
 * @param {boolean} hasMixedForecast
 * @param {string} perMonthAccordingToMode value of the perMonthAccordingToMode in containers/TimePlot.js
 * @param {string} yAxisLabel value of the yAxisLabel in containers/TimePlot.js
 *
 * @example
 * const getTimePlotComment = getTimePlotComment(
 * this.props.lang,
 * this.props.hasForecast,
 * this.props.hasMixedForecast,
 * perMonthAccordingToMode,
 * yAxisLabel,
 * );
 */

export function getTimePlotComment(
  lang,
  hasForecast,
  hasMixedForecast,
  perMonthAccordingToMode,
  yAxisLabel,
) {
  const productionNature = getProductionNatureLabel(
    lang,
    hasForecast,
    hasMixedForecast,
  );
  let timeplotComment;

  switch (lang) {
    case 'de':
      if (this.state.currentTech.solar) {
        if (this.state.currentTech.wind) {
          if (this.state.currentTech.windOffshore) {
            timeplotComment =
              productionNature +
              ' of solar energy and onshore and offshore wind energy ' +
              perMonthAccordingToMode +
              ', in ' +
              yAxisLabel;
          } else {
            timeplotComment =
              productionNature +
              ' of solar energy and onshore wind energy ' +
              perMonthAccordingToMode +
              ', in ' +
              yAxisLabel;
          }
        } else {
          if (this.state.currentTech.windOffshore) {
            timeplotComment =
              productionNature +
              ' of solar energy and offshore wind energy' +
              perMonthAccordingToMode +
              ', in ' +
              yAxisLabel;
          } else {
            timeplotComment =
              productionNature +
              ' of solar energy ' +
              perMonthAccordingToMode +
              ', in ' +
              yAxisLabel;
          }
        }
      } else {
        if (this.state.currentTech.windOffshore) {
          if (this.state.currentTech.windOffshore) {
            timeplotComment =
              productionNature +
              ' of onshore and offshore wind energy ' +
              perMonthAccordingToMode +
              ', in ' +
              yAxisLabel;
          } else {
            timeplotComment =
              productionNature +
              '  of onshore wind energy ' +
              perMonthAccordingToMode +
              ', in ' +
              yAxisLabel;
          }
        } else {
          timeplotComment =
            productionNature +
            '  of offshore wind energy ' +
            perMonthAccordingToMode +
            ', in ' +
            yAxisLabel;
        }
      }
      break;
    case 'en':
      if (this.state.currentTech.solar) {
        if (this.state.currentTech.wind) {
          if (this.state.currentTech.windOffshore) {
            timeplotComment =
              productionNature +
              ' of solar energy and onshore and offshore wind energy ' +
              perMonthAccordingToMode +
              ', in ' +
              yAxisLabel;
          } else {
            timeplotComment =
              productionNature +
              ' of solar energy and onshore wind energy ' +
              perMonthAccordingToMode +
              ', in ' +
              yAxisLabel;
          }
        } else {
          if (this.state.currentTech.windOffshore) {
            timeplotComment =
              productionNature +
              ' of solar energy and offshore wind energy' +
              perMonthAccordingToMode +
              ', in ' +
              yAxisLabel;
          } else {
            timeplotComment =
              productionNature +
              ' of solar energy ' +
              perMonthAccordingToMode +
              ', in ' +
              yAxisLabel;
          }
        }
      } else {
        if (this.state.currentTech.windOffshore) {
          if (this.state.currentTech.windOffshore) {
            timeplotComment =
              productionNature +
              ' of onshore and offshore wind energy ' +
              perMonthAccordingToMode +
              ', in ' +
              yAxisLabel;
          } else {
            timeplotComment =
              productionNature +
              '  of onshore wind energy ' +
              perMonthAccordingToMode +
              ', in ' +
              yAxisLabel;
          }
        } else {
          timeplotComment =
            productionNature +
            '  of offshore wind energy ' +
            perMonthAccordingToMode +
            ', in ' +
            yAxisLabel;
        }
      }
      break;
    case 'fr':
    default:
      if (this.state.currentTech.solar) {
        if (this.state.currentTech.wind) {
          if (this.state.currentTech.windOffshore) {
            timeplotComment =
              productionNature +
              " d'énergie solaire et éolienne onshore et offshore" +
              perMonthAccordingToMode +
              ', en ' +
              yAxisLabel;
          } else {
            timeplotComment =
              productionNature +
              " d'énergie solaire et éolienne onshore" +
              perMonthAccordingToMode +
              ', en ' +
              yAxisLabel;
          }
        } else {
          if (this.state.currentTech.windOffshore) {
            timeplotComment =
              productionNature +
              " d'énergie solaire et éolienne offshore" +
              perMonthAccordingToMode +
              ', en ' +
              yAxisLabel;
          } else {
            timeplotComment =
              productionNature +
              " d'énergie solaire et" +
              perMonthAccordingToMode +
              ', en ' +
              yAxisLabel;
          }
        }
      } else {
        if (this.state.currentTech.windOffshore) {
          if (this.state.currentTech.windOffshore) {
            timeplotComment =
              productionNature +
              " d'énergie éolienne onshore et offshore " +
              perMonthAccordingToMode +
              ', en ' +
              yAxisLabel;
          } else {
            timeplotComment =
              productionNature +
              " d'énergie éolienne onshore " +
              perMonthAccordingToMode +
              ', en ' +
              yAxisLabel;
          }
        } else {
          timeplotComment =
            productionNature +
            " d'énergie éolienne offshore " +
            perMonthAccordingToMode +
            ', en ' +
            yAxisLabel;
        }
      }
  }
  return timeplotComment;
}
